import React from 'react';

import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

import { OFFERS_HUB_CTA_URL_HELPER_TEXT, fieldLabel } from '~/utils/societePayloadBuilder/offersHub/fieldLabels';

import { PayloadBuilderTextField } from '../FormFields';

type OffersHubCtaUrlFieldProps = Omit<React.ComponentProps<typeof PayloadBuilderTextField>, 'label'>;

export default function OffersHubCtaUrlLabel() {
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      {fieldLabel('ctaUrl')}
      <InfoOutlinedIcon fontSize="inherit" color="action" />
    </Box>
  );
}

export function OffersHubCtaUrlField(props: OffersHubCtaUrlFieldProps) {
  return (
    <Tooltip title={OFFERS_HUB_CTA_URL_HELPER_TEXT} placement="top" arrow slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line' } } }}>
      <Box sx={{ width: '100%' }}>
        <PayloadBuilderTextField label={<OffersHubCtaUrlLabel />} {...props} />
      </Box>
    </Tooltip>
  );
}
